<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11L8 8" stroke="#F6AC00" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 6L8 5" stroke="#F6AC00" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M7.13622 2.48076C7.5221 1.81926 8.4779 1.81926 8.86378 2.48076L14.1227 11.4961C14.5116 12.1628 14.0308 13 13.259 13H2.74104C1.96925 13 1.48838 12.1628 1.87726 11.4961L7.13622 2.48076Z"
      stroke="#F6AC00"
    />
  </svg>
</template>
